var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBan2A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 100,
    viewBox: "0 0 81 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7pjz48pifa",
    d: "M28.994 42.85L10.235 75.338H3.568c-.946.008-1.856-.367-2.526-1.042-.619-.623-.986-1.453-1.036-2.329L0 71.748V70.18c.017-16.567 12.836-26.633 28.994-27.33zm14.587-.04c16.828 0 30.506 9.986 30.794 26.856l.005.513v1.57c.004.956-.371 1.874-1.042 2.548-.618.623-1.441.99-2.308 1.037l-.218.005H24.091l18.781-32.53.709.001zM38.119.96c4.737 0 9.08 1.691 12.46 4.504l-19.295 33.42c-7.412-2.778-12.69-9.943-12.69-18.345 0-10.813 8.742-19.58 19.525-19.58zm19.525 19.579c0 8.311-5.165 15.413-12.45 18.254l12.232-21.188c.143.957.218 1.937.218 2.934z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60 -55) translate(60 55)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.57) translate(0 .041)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#949494",
    fillRule: "nonzero",
    xlinkHref: "#7pjz48pifa"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 107.438,
    x: 42.496,
    y: -3.479,
    fill: "#949494",
    rx: 4.132,
    transform: "rotate(30 48.496 50.24)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBan2A);
export default __webpack_public_path__ + "static/media/icon-ban-2-a.a3b1ba5276b95411fb23d2baf94496f2.svg";
export { ForwardRef as ReactComponent };